/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({
  questionnaire,
}) {
  return questionnaire.map(question => {
    if ([1438].includes(question.idQuestion)) {
      question.behaviorObject.isRequired = questionnaire.find(question => question.idQuestion === 171)?.idAnswerOption === 1166;
      const feeDimension = question.childrenQuestions?.find(question => question.idQuestion === 1512);
      const { defaultValue } = feeDimension?.behaviorObject || {};

      for (const q of question.childrenQuestions || []) {
        q.visibleQuestion = true;
        q.behaviorObject.isRequired = questionnaire.find(question => question.idQuestion === 171)?.idAnswerOption === 1166;

        if (q.idQuestion === 1440 || q.idQuestion === 1510) {
          q.behaviorObject.isRequired = feeDimension?.idAnswerOption ? feeDimension?.idAnswerOption === 7089 : defaultValue === 7089;
          q.visibleQuestion = feeDimension?.idAnswerOption ? feeDimension?.idAnswerOption === 7089 : defaultValue === 7089;
        }

        if (q.idQuestion === 1441) {
          q.behaviorObject.isRequired = feeDimension?.idAnswerOption ? feeDimension?.idAnswerOption === 7090 : defaultValue === 7090;
          q.visibleQuestion = feeDimension?.idAnswerOption ? feeDimension?.idAnswerOption === 7090 : defaultValue === 7090;
        }
      }

      for (const q of questionnaire) {
        const feeDimension = question.childrenQuestions?.find(question => question.idQuestion === 1512) || questionnaire.find(question => question.idQuestion === 1512);
        const { defaultValue } = feeDimension?.behaviorObject || {};

        if (q.idQuestion === 1440 || q.idQuestion === 1510) {
          q.behaviorObject.isRequired = feeDimension?.idAnswerOption ? feeDimension?.idAnswerOption === 7089 : defaultValue === 7089;
          q.visibleQuestion = feeDimension?.idAnswerOption ? feeDimension?.idAnswerOption === 7089 : defaultValue === 7089;
        }

        if (q.idQuestion === 1441) {
          q.behaviorObject.isRequired = feeDimension?.idAnswerOption ? feeDimension?.idAnswerOption === 7090 : defaultValue === 7090;
          q.visibleQuestion = feeDimension?.idAnswerOption ? feeDimension?.idAnswerOption === 7090 : defaultValue === 7090;
        }
      }
    }
    
    return question;
  })
};

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaireUpdated,
  setFieldValue,
}) {
  try {
    let saveQuestionnaire = false;

    if (question.idQuestion === 1512) {
      saveQuestionnaire = true;
      const { idAnswerOption } = value;
  
      questionnaireUpdated = questionnaireUpdated.map(qst => {
        if (qst.idQuestion === 1440 || qst.idQuestion === 1510) {
          qst.visibleQuestion = idAnswerOption === 7089;
          qst.behaviorObject.isRequired = idAnswerOption === 7089;
        }
  
        if (qst.idQuestion === 1441) {
          qst.visibleQuestion = idAnswerOption === 7090; 
          qst.behaviorObject.isRequired = idAnswerOption === 7090;
        }
  
        return qst;
      })
    }

    if (saveQuestionnaire) setQuestionnaireUpdated(questionnaireUpdated);

  } catch (e) {
    console.log('BROKER_REMUNERATION - handleQuestionChange - error', e)
  }
};

function handleQuestionBlur({
  question,
  value,
  setFieldValue,
  formikRef,
  obligorGroup,
  setObligorGroup,
  index,
  values,
  setMaxValuePerc,
  mask,
  maskPercentage,
}) {
  try {

  } catch (e) {
    console.log("BROKER_REMUNERATION - handleQuestionBlur error", e)
  }
}

async function handleRequestSerproCnpj({
  question: rootQuestion,
  data,
  questionnaire,
  setQuestionnaire,
  setFieldValue,
}) {
  try {
    questionnaire = questionnaire.map(question => {

      return question;
    })

    setQuestionnaire(questionnaire);
  } catch (e) {
    console.log('BROKER_REMUNERATION - handleRequestSerproCnpj - error', e)
  }
};

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleQuestionBlur,
  handleRequestSerproCnpj,
};

export { events };